module.exports = __webpack_public_path__ + "static/media/Tag.5c34c98a.svg";